<template>
  <!-- 保单详情 -->
  <dialogWrap
    v-model="isShow"
    title="预警规则设置"
    :width="'828px'"
    :before-close="closeDialog"
    :close-on-click-modal="true"
  >
    <div v-loading="loading">
      <el-alert
        title="预警规则变更时，将在保存规则10分钟之后生效"
        type="info"
        :closable="false">
      </el-alert>
      <el-form class="mt16" ref="riskFormRef" :model="riskForm" :rules="riskRules" label-width="120px">
        <el-form-item label="风控判断标准" prop="configEnumList">
          <el-checkbox-group v-model="riskForm.configEnumList" @change="configEnumListChange">
            <el-checkbox v-for="item in allType" :key="item.name+item.code" :label="item.code">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="违章未处理" class="pendingViolateAmount" prop="pendingViolateAmount">
          <el-checkbox v-model="openPendingViolateScore" @change="transMoneyChange">违章未处理分数，按</el-checkbox>
          <span class="fraction_item"> <el-input :disabled="!openPendingViolateScore" v-model="riskForm.pendingViolateAmount" @input="fractionChange"></el-input></span>
          <span>元/分来进行计算</span>
        </el-form-item>
        <el-form-item label="预警规则" class="rule_list">
          <el-form-item
            v-for="(item, index) in riskForm.threshold"
            :key="index"
            :prop="'threshold.'+index+'.value'"
            :rules="{
              required: true, message: '请输入1~100的正整数', trigger: 'blur'
            }">
            <div class="risk_item mt16">
              <span>未缴纳费用达到押金的</span>
              <el-input v-model="item.value" v-number:percent.integer>
                <template slot="append">%</template>
              </el-input>
              <span>将被标记为 <el-button type="text">{{riskType[index]}}</el-button> </span>
            </div>
          </el-form-item>
        </el-form-item>
      </el-form>
    </div>
    <div v-show="!loading" slot="footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="confirm">确 定</el-button>
    </div>
  </dialogWrap>
</template>
<script>
import { recordConfigDetail, recordConfigEdit } from '@/api/domain/orders'
import { getEnum } from '@/api/global'
import ENUM from '../config/enum'
import { THRESHOLD_DEFAULT } from '../config/list'

export default {
  data() {
    return {
      allType: [], // 标准列表
      isShow: false,
      openPendingViolateScore: false,
      riskForm: {
        configEnumList: [],
        pendingViolateAmount: '', // 每分多少钱
        threshold: [], // 阈值
      },
      riskRules: {
        // configEnumList: { validator: this.validateConfig, trigger: 'blur' },
        pendingViolateAmount: { validator: this.validateMoney, trigger: 'blur' },
      },
      riskType: Object.values(ENUM.level).filter((item) => item !== '无风险'), // 风险对应的汉字
      loading: false,
      submitLoading: false,
      scopeEnumVal: 90, // 违章未处理分数对应的 枚举
    }
  },
  watch: {
    isShow(n) {
      if (!n) return
      this.getConfigDetail()
      this.getConfigEnum()
    },
  },
  methods: {
    // 校验风控判断标准
    // validateConfig (rule, value, callback) {
    //   if (this.riskForm.configEnumList.length === 0 && !this.openPendingViolateScore) {
    //     callback(new Error('请选择风控判断标准'))
    //     return
    //   }
    //   callback()
    // },
    // 风控判断标准改变
    configEnumListChange() {
      this.$refs.riskFormRef.validateField('configEnumList')
    },
    // 获取全部标准
    getConfigEnum() {
      getEnum({ type: 'riskConfigItem' }).then((res) => {
        this.allType = res.data ? res.data.filter((item) => item.code !== this.scopeEnumVal) : []
      })
    },
    // 获取配置详情
    getConfigDetail() {
      this.loading = true
      recordConfigDetail().then((res) => {
        if (res.code !== 1) return
        this.loading = false
        const { lowLevel, midLevel, highLevel, dangerLevel, configEnumList, pendingViolateAmount } = res.data
        this.riskForm.threshold = [{ value: lowLevel }, { value: midLevel }, { value: highLevel }, { value: dangerLevel }]
        this.riskForm.configEnumList = configEnumList || []
        this.riskForm.pendingViolateAmount = pendingViolateAmount || ''
        // 违章未处理分数是否转换为金钱
        if (configEnumList.indexOf(this.scopeEnumVal) > -1) {
          this.openPendingViolateScore = true
        }
      }).catch(() => {
        this.loading = false
      })
    },
    validateMoney(rule, value, callback) {
      if (value === '' && this.openPendingViolateScore) {
        callback(new Error('请输入金额'))
        return
      }
      callback()
    },
    transMoneyChange(v) {
      this.riskForm.pendingViolateAmount = ''
      this.$refs.riskFormRef.validateField('pendingViolateAmount')
    },
    // 限制数字范围
    astrictRange(val, min = 0, max = 100) {
      if (val === 0) return ''
      if (!val || !Number.isInteger(val)) return min
      val = val < min ? min : val
      val = val > max ? max : val
      return val
    },
    // 禁止输入0开头的正整数
    astrictInteger(val) {
      return val.replace(/^0*|\D/g, '')
    },
    // 金额输入
    fractionChange(v) {
      this.riskForm.pendingViolateAmount = this.astrictRange(Number(this.astrictInteger(v)), 1, 10000)
    },
    // eslint-disable-next-line vue/no-unused-properties -- 由父组件通过 $refs 调用打开弹窗
    showDialog() {
      this.submitLoading = false
      this.isShow = true
    },
    closeDialog() {
      this.isShow = false
      this.openPendingViolateScore = false
      this.riskForm = {
        configEnumList: [],
        pendingViolateAmount: '',
        threshold: THRESHOLD_DEFAULT.map((item) => ({ value: item })),
      }
      this.$refs.riskFormRef.resetFields()
    },
    confirm() {
      if (this.submitLoading) return
      this.$refs.riskFormRef.validate((valid) => {
        if (!valid) return
        if (!this.judgeThreshold()) {
          this.$message.warning('预警规则，较高风险的阈值必须大于较低风险的阈值，请仔细检查！')
          return
        }
        const params = {};
        ['lowLevel', 'midLevel', 'highLevel', 'dangerLevel'].forEach((item, index) => {
          params[item] = this.riskForm.threshold[index].value || ''
        })
        params.pendingViolateAmount = this.riskForm.pendingViolateAmount
        params.configEnumList = this.riskForm.configEnumList
        // 违章分数转为金额需将枚举加入configEnumList
        if (this.openPendingViolateScore) {
          params.configEnumList.push(this.scopeEnumVal)
        } else {
          params.configEnumList = params.configEnumList.filter((item) => item !== this.scopeEnumVal)
        }
        this.submitLoading = true
        recordConfigEdit(params).then((res) => {
          if (res.code !== 1) {
            this.submitLoading = false
            return
          }
          this.isShow = false
          this.$message.success('设置成功')
          this.$emit('setSuccess')
        }).catch(() => {
          this.submitLoading = false
        })
      })
    },
    // 校验阈值是否合法
    judgeThreshold() {
      const arr = this.riskForm.threshold.filter((item) => item.value)
      const len = arr.length
      // 较高风险的阈值是否大于较低风险的阈值
      const flag = arr.every((item, index) => (index + 1 < len ? Number(item.value) < Number(arr[index + 1].value) : true))
      return flag
    },
  },
}
</script>
<style lang="scss" scoped>
.risk_item .el-input--small{
  width: 164px;
}
.fraction_item .el-input--small{
  width: 114px;
}
.risk_item:first-child{
  margin-top: 0;
}
.pendingViolateAmount{
  ::v-deep .el-form-item__error{
    margin-left: 150px;
  }
}
.rule_list{
  ::v-deep .el-form-item__error{
    margin-left: 145px;
  }
}
</style>
